// extracted by mini-css-extract-plugin
module.exports = {"text":"ArchivedCommentsThresholdNotification-text-719cce2f68d1cd74421b68870d60a9d5"};